import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { ShopContext } from '../../data/shop/ShopConf';
import { getConfiguration, getCurrencyValue } from '../../data/utils';
import { getLabel } from '../../data/labels';

function LastTicketWidget(props) {
	const betslipContext = useContext(BetslipContext);
    const lastTickets = props.lastTickets;
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
	const shopContext = useContext(ShopContext);
    
	function getLastFourId(ticket){
		if(ticket != null && ticket.length > 0){
			ticket = getShowableId(ticket);
			if(ticket.length <= 4){
    			return ticket;
    		}
    		const len = ticket.length;
    		return ticket.substring(len - 4, len);
		}
	}
	
	function getShowableId(ticket){
		if(ticket != null && ticket.length > 4){
			if(shopContext.enabled && shopContext.skinProperties && shopContext.skinProperties.hideTerminalTicket){		
				const ln = ticket.length;
				ticket = ticket.substr(0, ln - 4);
				ticket += '****';							
			}
		}
		return ticket;
		
    }
    
    function reloadTicket(idTicket){
	   betslipContext.reloadTicket(idTicket);
    }
    
	return (
        <>
            {conf.lte &&
                <div className="widget-ultimi bg-bianco bordo-tondo margine-giu widget-betslip">
                <div className="titolo-widget-stampa maiuscolo bg-nero bianco bordo-tondo-alto-sx bordo-tondo-alto-dx">
                    <span><i className="fas fa-circle"></i> {getLabel('carrello.last_tickets_widget.title')}</span>
                </div>
                <div className="contenuto-widget-ultime-v bordato-widget">
                    <div className="d-grid ultimi-ticket headerCol allinea-centro">
                        <span className="testo-1-25">{getLabel('carrello.last_tickets_widget.ticket')}</span>
                        <span className="testo-1-25">{getLabel('carrello.last_tickets_widget.amount')}</span>
                        <span className="testo-1-25">{getLabel('carrello.last_tickets_widget.winnings')}</span>
                    </div>
                    {lastTickets.map((t, i) => {
                        return (
                            <div onClick={() => {reloadTicket(t.id)}} title={(getLabel('carrello.reload_last_ticket')) + ' ' + getShowableId(t.id)} key={i} className="pointer d-grid ultimi-ticket allinea-centro">
                                <span > {getLastFourId(t.id)}</span>
                                <span>{getCurrencyValue(t.amount, mult, nDec, currency)}</span>
                                <span>{getCurrencyValue(t.win, mult, nDec, currency)}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
            }
        </>
	);
}

export default LastTicketWidget;